import ArrowForwardIcon from 'assets/svg/arrow/arrow-forward-bold.svg'
import DailyDealsCard from 'common/components/Card/ProductDailyDealsCard'
import theme from 'common/theme'
import React, { useState } from 'react'
import styled from 'styled-components'

const control = `
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: 40px;
  height: 40px;
  margin-top: -22px;
  box-shadow: 0 6px 16px 0 rgba(134, 134, 134, 0.14);
  background-color: ${theme.colors.white};
  border-radius: 50%;
  user-select: none;
  justify-content: center;
  align-items: center;
  display: flex;
`

const Prev = styled.a`
  ${control};
  left: 0;
  display: ${(props) => (props.show ? 'flex' : ' none')};
`

const Next = styled.a`
  ${control};
  right: 0;
  display: ${(props) => (props.show ? 'flex' : ' none')};
`

const DailyDealsCardContainer = styled.div`
  height: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 20px;
  transform: translateX(-${(props) => props.transform}px);
  transition: transform 0.5s ease;
`

const StyledDailyDealsCard = styled.div`
  margin: 0 0 0 20px;
`

const Container = styled.div`
  width: 100vw;
  height: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  position: relative;
`

const RightArrow = styled(ArrowForwardIcon)``

const LeftArrow = styled(ArrowForwardIcon)`
  transform: scaleX(-1);
`

interface ICarousel {
  products?: any[]
  isBannerExist?: boolean
  onClickArrowDailyDealsList?: any
  onClickProductDailyDeals?: any
}

function Carousel({
  products = [],
  isBannerExist,
  onClickArrowDailyDealsList = () => null,
  onClickProductDailyDeals = () => null,
}: ICarousel): JSX.Element {
  const [transform, setTransform] = useState<number>(0)
  const [currentSlide, setCurrentSlide] = useState(1)

  /*
  slideWidth = isBannerExist ? 800 : 1000
  720 = (3 card * 220px of card width) + (3 card * 20px of card gap)
  960 = (4 card * 220px of card width) + (4 card * 20px of card gap)
  */
  const slideWidth = isBannerExist ? 720 : 960

  const cardPerSlide = isBannerExist ? 3 : 4
  const remainingWidth = isBannerExist ? 60 : 40
  const cardWidth = 220
  const gapWidth = 20

  const slideTotal = Math.ceil(products.length / cardPerSlide)

  /*
    - 1 => because slide start from array index 1
  */

  const onClickRightArrow = () => {
    const nextSlide = currentSlide + 1
    setCurrentSlide(nextSlide)
    const modResult = products.length % cardPerSlide
    const nextTransform =
      ((modResult + cardPerSlide - 1) % cardPerSlide) *
        (cardWidth + gapWidth) +
      remainingWidth
    if (nextSlide === slideTotal) {
      setTransform(transform + nextTransform)
    } else {
      setTransform(transform + slideWidth)
    }
  }

  const onClickLeftArrow = () => {
    const nextSlide = currentSlide - 1
    setCurrentSlide(nextSlide)
    const modResult = products.length % cardPerSlide
    const prevTransform =
      ((modResult + cardPerSlide - 1) % cardPerSlide) *
        (cardWidth + gapWidth) +
      remainingWidth
    if (currentSlide === slideTotal) {
      setTransform(transform - prevTransform)
    } else {
      setTransform(transform - slideWidth)
    }
  }

  const onClickPrev = () => {
    onClickLeftArrow()
    onClickArrowDailyDealsList()
  }

  const onClickNext = () => {
    onClickRightArrow()
    onClickArrowDailyDealsList()
  }

  return (
    <Container data-testid="carousel-test">
      <DailyDealsCardContainer transform={transform}>
        {products?.map((product, index) => {
          const onClickProduct = () => {
            onClickProductDailyDeals({
              ...product,
              index,
            })
          }
          return (
            <StyledDailyDealsCard key={`${index + 1}`}>
              <DailyDealsCard
                percentage={product?.discount_percentage}
                maskedPrice={product?.masked_price}
                maskedDiscount={product?.masked_discount}
                image={product.default_image}
                name={product.name}
                currentPrice={product.discount}
                previousPrice={product.price}
                availableProduct={product.remaining_quantity}
                totalProduct={product.quantity}
                productURL={product.link}
                onClickProduct={onClickProduct}
              />
            </StyledDailyDealsCard>
          )
        })}
      </DailyDealsCardContainer>
      <Prev
        data-testid="carousel-control-prev-test"
        show={currentSlide !== 1}
        onClick={() => onClickPrev()}
      >
        <LeftArrow />
      </Prev>
      <Next
        data-testid="carousel-control-next-test"
        show={slideTotal > 1 && currentSlide !== slideTotal}
        onClick={() => onClickNext()}
      >
        <RightArrow />
      </Next>
    </Container>
  )
}

export default Carousel
